export { Spinner, type SpinnerProps } from "./spinner";
